export default "__VITE_ASSET__B0b0aRKd__"